import EfVideo from '@elem/ui/ef-video';
import css from './index.module.scss';
import EfSpec from '@elem/ui/ef-spec';
import { useLang } from '@/i18n';
import { useEffect, useState } from 'react';

export default function B() {
    const { t } = useLang('delta_pro_ultra.launch.detail.OASIS');
    const [source, setSource] = useState('');
    useEffect(() => {
        if (typeof window !== 'undefined') {
            const scene = AniContainer.create({
                triggerElement: '.dpu-detail-I',
                triggerHook: 1,
                offset: '100%',
                onEnter: () =>
                    setSource(
                        window?.innerWidth >= 768
                            ? 'https://websiteoss.ecoflow.com/upload/video/1735787139051/backup_priority.mp4'
                            : 'https://websiteoss.ecoflow.com/upload/video/1735787353496/backup_proority_M.mp4',
                    ),
            });
            return () => {
                scene.destroy();
            };
        }
    }, []);
    return (
        <>
            <EfSpec />
            <section className={`OASIS-C ${css['OASIS-C']}`}>
                <div className="info">
                    <h2 className="title">{t('D_title')}</h2>
                    <p className="desc">{t('D_desc')}</p>
                </div>
                <div className="video-box">
                    {source && (
                        <EfVideo
                            pc={source}
                            poster="https://websiteoss.ecoflow.com/upload/image/1735787270229/backup_priority.jpg"
                            posterH5="https://websiteoss.ecoflow.com/upload/image/1735787431397/backup_proority_M.jpg"
                            loop={true}
                            autoPlay={true}
                        />
                    )}
                </div>
            </section>
        </>
    );
}
